<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> CANCELAMENTO DE FATURA REEMBOLSO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-select
                :items="companies_options"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company_selected"
                multiple
                small-chips
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="company_selected.length === 1 && index === 0">
                    <span>{{ item.name }}</span>
                  </span>
                  <span v-if="index === 1 && company_selected.length > 0">
                    {{ company_selected.length }} Franqueados Selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="search"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap">
                                <v-checkbox
                                  v-model="checkall"
                                  hide-details
                                  :indeterminate="checkall === null"
                                  label=""
                                  class="mt-1"
                                  @click="handleClickCheckAll"
                                ></v-checkbox>
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Filial
                              </th>
                              <th class="text-left fs-12" width="450px">
                                Franqueado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Documento
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Faturamento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Documento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Parcelas
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="company in companies" :key="company.id">
                              <td>
                                <v-checkbox
                                  v-model="companies_cancel"
                                  :value="company.id"
                                  hide-details
                                  label=""
                                  class="mt-1"
                                  @click="handleClickSelectCompany(company)"
                                ></v-checkbox>
                              </td>
                              <td>
                                {{ company.code }}
                              </td>
                              <td>
                                {{ company.name }}
                              </td>
                              <td>{{ company.code }}-{{ company.document }}</td>
                              <td>
                                {{ company.created_at }}
                              </td>
                              <td class="text-right">
                                {{ company.value }}
                              </td>
                              <td class="text-right">
                                {{ company.parcels }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="companies.length > 0">
                            <tr>
                              <th colspan="13">
                                Total de Faturas Selecionados:
                                {{ companies_cancel.length }} de
                                {{ companies.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    dark
                    color="green darken-3"
                    class="float-right"
                    small
                    @click="handleConfirmCancel"
                  >
                    Confirmar Cancelamento
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog v-model="dialogCancel" max-width="400px">
      <v-card>
        <v-toolbar color="red lighten-1" dark class="text-h5"
          >Atenção</v-toolbar
        >
        <v-card-title class="text-h6">
          Tem certeza que deseja realmente <br />Cancelar essa Fatura de
          Reembolso?
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  :items="reasons"
                  item-text="description"
                  item-value="id"
                  v-model="reason"
                  :error="error_reason"
                  label="Motivo Para o Cancelamento"
                  required
                  :rules="[rules.required]"
                  @change="() => (error_reason = false)"
                  class="mt-5"
                  dense
                  outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  outlined
                  no-resize
                  dense
                  name="input-7-4"
                  label="Observação"
                  class="text-area-uppercase"
                  :value="observation"
                  @input="(value) => (observation = value)"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeCancel">Fechar</v-btn>
          <v-btn color="red darken-1" dark @click="cancelItemConfirm">
            <v-icon dark>mdi-delete</v-icon>
            Cancelar Fatura
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    reasons: [
      // { value: 1, text: "Erro de Digitação" },
      // { value: 2, text: "Erro no Parcelamento" },
      // { value: 3, text: "Evento Cancelado" },
      // { value: 4, text: "Franqueado Incorreto" },
    ],
    reason: "",
    observation: "",
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    companies: [],
    showAlert: false,
    typeAlert: "error",
    messageAlert: "",
    companies_cancel: [],
    dialogCancel: false,
    checkall: false,
    error_reason: false,
    rules: {
      required: (value) => !!value || "Campo Obrigatorio",
    },
    companies_options: [],
    company_selected: [],
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getCompanies();
      await this.getReasonsCancellation();
    },
    validate() {},
    async getCompanies() {
      this.loading = true;
      this.companies_options = [];
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies_options = data.sort((a, b) =>
          a.code > b.code ? 1 : -1
        );
      } catch (error) {
        this.companies_options = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getReasonsCancellation() {
      this.loading = true;
      this.reasons = [];
      try {
        let response = await fetch(`${URL}reason-cancellation-refund`);
        let res = await response.json();
        this.reasons = res.sort((a, b) =>
          a.description > b.description ? 1 : -1
        );
      } catch (error) {
        console.log(error);
        this.messageAlert =
          "Não foi possível carregar os Motivos de Cancelamento, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async search() {
      this.checkall = false;
      this.showAlert = false;
      this.loading = true;
      this.companies = [];
      this.companies_cancel = [];

      let data = {};
      data.month = this.month;
      data.year = this.year;
      data.company = this.company_selected;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}refund/search`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let res = await response.json();
        if (res.length > 0) {
          this.companies = res.sort((a, b) => (a.code > b.code ? 1 : -1));
        } else {
          this.showAlert = true;
          this.typeAlert = "warning";
          this.messageAlert =
            "Nenhuma Fatura disponível para ser cancelada com os filtros selecionados";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleConfirmCancel() {
      if (this.companies_cancel.length > 0) {
        this.dialogCancel = true;
        this.reason = "";
        this.error_reason = false;
        this.observation = "";
      } else {
        this.typeAlert = "error";
        this.messageAlert =
          "É preciso selecionar pelo menos uma fatura para cancelar";
        this.showAlert = true;
      }
    },
    closeCancel() {
      this.dialogCancel = false;
    },
    async cancelItemConfirm() {
      if (this.reason == "") {
        this.error_reason = true;
        return false;
      }
      this.dialogCancel = false;
      this.loading = true;
      try {
        let data = {};
        data.companies = this.companies_cancel
          .map((item) => this.companies.find((i) => i.id === item))
          .map((item) => ({
            id: item.id,
            document: item.document,
            company_id: item.company_id,
            date_billing: item.created_at.split("/").reverse().join("-"),
            value: item.value,
            parcels: item.parcels,
          }));
        data.reason = this.reason;
        data.observation = this.observation.toUpperCase();
        data.month = this.month;
        data.year = this.year;
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}refund/group_cancel`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let res = await response.json();
        console.log(res);
        this.checkall = false;
        this.showAlert = true;
        this.reason = "";
        this.messageAlert = "Faturas Canceladas com Sucesso";
        this.typeAlert = "success";
        this.companies_cancel = [];
        this.companies = [];
      } catch (error) {
        console.log(error);
        this.showAlert = true;
        this.messageAlert = error.message;
        this.typeAlert = "error";
      } finally {
        this.loading = false;
      }
    },
    handleClickSelectCompany() {
      if (this.companies.length === this.companies_cancel.length) {
        this.checkall = true;
      } else if (this.companies_cancel.length === 0) {
        this.checkall = false;
      } else {
        this.checkall = null;
      }
    },
    handleClickCheckAll() {
      if (this.companies.length === this.companies_cancel.length) {
        this.checkall = false;
        this.companies_cancel = [];
      } else {
        this.checkall = true;
        this.companies_cancel = this.companies.map((company) => company.id);
      }
      //  else {
      //   this.checkall = null;
      // }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
